import MenuIcon from "@mui/icons-material/Menu";
import { Box, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { TabChoices } from "routing/constants";
import { tabToPath } from "routing/routeSpecs";
import { UserProps } from "types/users";
import { tabIsAccessible } from "utils/accesibleTabsUtils";

export default function TemporaryDrawer(props: UserProps) {
  const { user } = props;
  const [open, setOpen] = React.useState(false);

  const drawerRoutes: Array<JSX.Element> = [];
  Object.keys(TabChoices).map((choice) =>
    tabIsAccessible(choice, user)
      ? drawerRoutes.push(
        <Link key={choice} to={tabToPath(choice as TabChoices)}>
          <ListItem button>
              <ListItemText primary={choice} />
            </ListItem>
          </Link>
        )
      : undefined
  );

  const toggleDrawer = (openToggle: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    setOpen(openToggle);
  };

  const list = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
      <List>{drawerRoutes}</List>
    </Box>
  );

  return (
    <Box className="block sm:hidden">
      <IconButton className="text-white" aria-label="menu" onClick={toggleDrawer(true)}>
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        {list}
      </Drawer>
    </Box>
  );
}
